<template>
  <div class="form-container">
    <div class="title-wrap">
      <a-row>
        <a-col :span="18" :offset="3"> <span class="title">欢迎登录</span> </a-col>
      </a-row>
    </div>
    <CustomForm
      :formRootInstance="formRootInstance"
      :formRules="formRules"
      :initModel="initModel"
      :tempModel="tempModel"
      :submitButtonOptions="submitButtonOptions"
      :curCaptchaPath="curCaptchaPath"
      @refreshAuthCode="getCaptchaPath"
      @submit="handleSubmitForm">
    </CustomForm>
    <Loading :loading="loading" />
    <!-- 弹窗 -->
    <custom-modal :title="modalTitle" :modalVisible="modalVisible">
      <ModalStatus
        btnTitle="确定"
        :headTitle="headTitle"
        :btnList="btnList"
        @cancel="() => (modalVisible = false)"
        @exitLogin="emailLogin"/>
    </custom-modal>
  </div>
</template>

<script>
// import qs from 'qs'
import { mapGetters, mapMutations } from 'vuex'
import encrypt from '@/utils/cryptoJs.js'
import CustomForm from '@/components/CustomForm/index'
import CustomModal from '@/components/CustomModal/index'
import Loading from '@/components/Loading/index'
import ModalStatus from '@/components/Modals/ModalStatus'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinLogin from '../mixins/index'
// import { checkToken, emailToken } from '@/api/user'
import { MODAL_FOOTER_CONFIG } from '../config/modal'
import { captchaImage } from '@/api/user'
// import { captchaImage, Login } from '@/api/user'

export default {
  mixins: [mixinConfigSetting, mixinLogin],
  components: {
    CustomForm,
    CustomModal,
    ModalStatus,
    Loading
  },
  props: {
    formConfig: Object // 表单配置对象(在mixinConfigSetting 中统一处理了)
  },
  data() {
    return {
      modalVisible: false,
      modalTitle: '', // 弹窗标题
      headTitle: '', // 弹窗内部标题
      btnList: MODAL_FOOTER_CONFIG.btnList,
      uuid: ''
    }
  },
  mounted() {
    // 验证码
   // this.getCaptchaImage()
  },
  computed: {
    ...mapGetters('user', [
      'role',
      'account',
      'visitor',
      'token'
    ])
  },
  methods: {
    ...mapMutations('user', [
      'SET_ACCOUNT',
      'SET_ROLE',
      'SET_TOKEN'
    ]),
    getCaptchaImage() {
      captchaImage().then((res) => {
        if (res.code === 200) {
          this.curCaptchaPath = `data:image/gif;base64,${res.img}`
          this.uuid = res.uuid
        }
      })
    },
    getCaptchaPath() {
      this.getCaptchaImage()
    },
    handleSubmitForm(formValue) {
      this.callWithHandlerError(async () => {
        const { form } = formValue
        this.normalizeLoginForm(form) // 格式化表单
        this.$store.dispatch('user/LoginForm',form).then((res)=>{
          if(res.code === 200){
            this.$message.success('登录成功!')
            this.emailLogin() // 执行登录逻辑
            //this.$store.commit('headerMenu/updateMenuList',res.role)
          }else{
            //this.getCaptchaPath() // 重新获取验证码
            this.$message.warning(res.msg)
          }
        })
      })
    },
    normalizeLoginForm(form) { // 标准化参数
      const { password, email } = form
      this.loginForm = {
        client_id: window.APP_CONFIG.loginData.client_id,
        client_secret: window.APP_CONFIG.loginData.client_secret,
        grant_type: 'password',
        email,
        password: encrypt(password, this.uuid),
        code: form.code,
        uuid: this.uuid,
        crowd_out: false,
        scope: 'select'
      }
      form.uuid = this.uuid
      // this.checkToken(email)
    },
    async emailLogin() {
      this.$router.push('/index')
    }
  }
}
</script>